"use client";

interface RatingStarsProps {
  rating: number;
  reviews?: number;
}

export function RatingStars({ rating, reviews }: RatingStarsProps) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.25 && rating - full < 0.75;
  const total = 5;

  return (
    <span className="rating-stars">
      {Array.from({ length: total }, (_, i) => {
        const filled = i < full || (i === full && hasHalf);
        return (
          <svg
            key={i}
            className={`rating-stars__star ${filled ? "rating-stars__star--filled" : ""}`}
            viewBox="0 0 12 12"
            fill={filled ? "currentColor" : "none"}
            stroke="currentColor"
            strokeWidth="0.8"
          >
            <path d="M6 1l1.5 3.5L11 5l-2.5 2.5L9 11 6 9.5 3 11l.5-3.5L1 5l3.5-.5L6 1z" />
          </svg>
        );
      })}
      {reviews !== undefined && (
        <span style={{ marginLeft: 4 }}>({reviews})</span>
      )}
    </span>
  );
}
